/**
 * Owner: Masa Bayu
 * File: element-type.ts
 * Date:Time: 2026-09-05 06:59
 * Description: Discriminated QXW element type contract.
 */
export const QX_ELEMENT_VERSION = '1.0.0';
export const QX_ELEMENT_TYPES = [
    'text',
    'image',
    'svg',
    'shape',
    'group',
    'component',
    'video',
    'audio',
    'embed',
    'overlay',
];
//# sourceMappingURL=element-type.js.map